import LoginSection from "../components/header/LoginSection";
import HeaderButtonComponent from "../components/header/HeaderButtonComponent";
import RightArrowIcon from "../../assets/icons/header-icons/right-arrow-white.svg";
import { Navigate, useNavigate } from "react-router-dom";
import { useAppSelector } from "@hypexone/uicore";
import { BRAND_NAME, domain } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/brandConfig";

const MobileLoginPage = () => {
  const navigate = useNavigate();
  const { langData } = useAppSelector((state) => state.cms);
  const { loggedIn } = useAppSelector((state) => state.auth);

  if (loggedIn) {
    return <Navigate to="/home" replace />;
  }

  return (
    <div className="flex flex-col h-full w-full px-4 pt-3 pb-5 bg-gradient-to-r from-blue2 via-blue1 to-blue3">
      <div className="shrink-0">
        <HeaderButtonComponent
          leftIcon={{
            src: RightArrowIcon,
            alt: "right-arrow",
            customClassName: "h-2.5 w-2.5 scale-x-[-1]",
          }}
          onClick={() => navigate(-1)}
          buttonText={langData?.["back"]}
        />
      </div>

      <div className="flex flex-col flex-1 gap-3 items-center justify-start pt-1 overflow-y-auto hide-scrollbar">
        <img
          src={getEnvVariable(domain, "logo")}
          alt={BRAND_NAME ?? "logo"}
          className={`${getEnvVariable(domain, "logoClassName") || "h-[88px] object-contain"} my-[30px]`}
        />

        <LoginSection isMobileScreen />
      </div>
    </div>
  );
};

export default MobileLoginPage;
